import React from 'react'
import './payment.css';
import { Typography } from '@mui/material';


export default function Success() {
  return (
    <div className='successPage'>
        <div className='pop-up'>
            <Typography variant='h5'>Payment Successful</Typography>
            <img src='https://media1.tenor.com/images/e5b5495b4c0fcb9cd05779d8e010bad6/tenor.gif?itemid=18188570' style={{width:'100px', height:'100px', borderRadius:'50%'}} />
        </div>
    </div>
  )
}
